import script from "./LLMPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./LLMPage.vue?vue&type=script&setup=true&lang=ts"

import "./LLMPage.vue?vue&type=style&index=0&id=0f8dc188&scoped=true&lang=scss"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f8dc188"]])

export default __exports__